import { useQuery } from "@tanstack/react-query";
import { queryKeys } from "./common";
import { API_BASE } from "../constants";

export const getConsigneeIds = async () => {
  const path = `${API_BASE}/api/consignee`;
  const response = await fetch(path);

  if (!response.ok) {
    throw new Error("Failed to fetch consignee IDs");
  }

  const data: string[] = await response.json();
  return await data;
};

export const useGetConsigneeIds = () => {
  return useQuery({
    queryKey: queryKeys.consigneeIds,
    queryFn: () => getConsigneeIds(),
    staleTime: Infinity,
  });
};
